
import { Options, Vue } from "vue-class-component";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";

@Options({
  name: "TheHeaderMetaInfo",
})
export default class MetaInfo extends Vue {}
